<template>
  <b-modal
    ref="addFullCalendarModal"
    hide-footer
    centered
    title="Create Full Calendar"
    >
    <b-form @submit.prevent="save">
      <b-form-group label="Calendar ID:">
        <b-form-input
          v-model.trim="$v.calendarId.$model"
          :class="{ 'is-invalid': $v.calendarId.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback v-if="!$v.calendarId.required">
          Calendar ID is required
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.calendarId.isUnique">
          Calendar with the same ID already exists
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Table title:"
        >
        <b-form-input
          type="text"
          v-model.trim="$v.gridTitle.$model"
          :class="{ 'is-invalid': $v.gridTitle.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.gridTitle.required"
          >
          Table title is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Source data type:"
        >
        <b-form-select
          v-model.trim="$v.gridStorageType.$model"
          :class="{ 'is-invalid': $v.gridStorageType.$error }"
          :options="gridStorageTypes"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.gridStorageType.required"
          >
          Source data type is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Source data path:"
        >
        <b-form-input
          type="text"
          v-model.trim="$v.gridSource.$model"
          :class="{ 'is-invalid': $v.gridSource.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.gridSource.required"
          >
          Source data path is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Save Table on tab:"
        >
        <b-form-select
          v-model.trim="gridOnTab"
          :options="tabs"
          :disabled="inProgress"
        />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        :disabled="inProgress"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      inProgress: false,
      calendarId: null,
      calendars: [],
      dataGrids: [],
      gridTitle: null,
      gridStorageTypes: [],
      gridStorageType: null,
      gridSource: null,
      tabs: [],
      gridOnTab: null,
      gsOptions: {}
    }
  },
  watch: {
    currentTab () {
      if (!this.gridOnTab) this.gridOnTab = this.currentTab
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab'
    ])
  },
  methods: {
    save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      const vm = this
      const data = {
        calendarId: vm.calendarId,
        gridTitle: vm.gridTitle,
        gridStorageType: vm.gridStorageType,
        gridSource: vm.gridSource,
        gridOnTab: vm.gridOnTab,
        currentTab: vm.currentTab,
        subtab: this.currentSubTab,
        gsOptions: this.gsOptions
      }

      db.fullCalendar.create(data, (key) => {
        this.inProgress = false;
        this.gsOptions = {};
        this.$v.$reset();
        this.$store.commit('addedWidgetKey', key);
        if (this.$refs.addFullCalendarModal) this.$refs.addFullCalendarModal.hide()
      })
    }
  },
  validations: {
    calendarId: {
      required,
      isUnique (val) {
        if (!val || this.inProgress) return true
        if (~this.calendars.indexOf(val)) return false
        return true
      }
    },
    gridTitle: {
      required
    },
    gridStorageType: {
      required
    },
    gridSource: {
      required
    }
  },
  created () {
    db.fullCalendar.getIds((calendars) => {
      if (calendars) this.calendars = calendars
      else this.calendars = []
    })

    db.dataGrid.options.readAll((dataGrids) => {
      this.dataGrids = []

      if (dataGrids) {
        for (let gridId in dataGrids) {
          this.dataGrids.push(gridId)
        }
      }
    })

    db.getRef('workspaceAccess').once('value', (snapshot) => {
      this.gridStorageTypes = [
        { value: 'user', text: 'User model'},
        { value: 'dashboard', text: 'Dashboard model'}
      ]
      if (snapshot.val()) this.gridStorageTypes.push({ value: 'workspace', text: 'Workspace model' })
    })

    db.tabs.read((tabs) => {
      const t = []

      for (let tabKey in tabs) {
        const tab = tabs[tabKey]

        t[tab.order] = {
          text: tab.title,
          value: tabKey
        }
      }

      const vm = this
      this.tabs = t
    })

    eventBus.$on('showAddFullCalendarModal', ({gsOptions}) => {
      if (this.$refs.addFullCalendarModal) {
        this.gsOptions = gsOptions;
        this.$refs.addFullCalendarModal.show()
      }
    })
  },
  mounted () {
    if (this.$refs.addFullCalendarModal) {
      $(this.$refs.addFullCalendarModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addFullCalendarModal) {
      $(this.$refs.addFullCalendarModal['$el']).remove()
    }
  }
}
</script>
